import { MainDocContentTypeResponse } from '@cs-cms/types';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { contentTypesKeys } from '../../queryKeys/contentTypes';

export function useGetContentType(
  ctName?: string,
  locale?: string
): UseQueryResult<MainDocContentTypeResponse, unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getContentType = () => {
    if (servicesCtx?.contentTypesService && ctName) {
      return servicesCtx.contentTypesService.getContentType(ctName, locale);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: contentTypesKeys.byCtName(ctName, locale),
    queryFn: getContentType,
    retry: 0,
    staleTime: 180000,
    gcTime: 180000,
    enabled: !!ctName
  });
}
